import React, { useMemo, useRef } from "react";
import { FilteredZooMembershipDto } from "../../Models/FilteredZooConstituentDto";
import { useAccount } from "../../Contexts/AccountContext";
import JsBarcode from 'jsbarcode';
import Barcode from "../Barcode";


export default ({membership}:{membership: FilteredZooMembershipDto}) => {
    const { memberships, household } = useAccount();

    // Format date as "DD/MM/YYYY" (e.g., "15/01/2023")
    const formatDate = (date: Date): string => {
        if (!date) return '';
        
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        
        return `${month}/${day}/${year}`;
    };
    
    // Format the expiration date
    const formattedExpirationDate = membership.parsedExpirationDate ? 
        formatDate(membership.parsedExpirationDate) : '';

return <div className="card">
        <div className="card-body">
            <div className="row">
                <div className="col-12 col-sm-4">
                    <img src={window.baseApiUrl + "/ecom/client/images/ZSM_Logo_BW.png"} alt="BW Logo" className="img-fluid" />
                </div>
                <div className="col-12 col-sm">
                    <div className="d-flex justify-content-center">
                    <Barcode value={household?.id?.toString()} width={3} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-sm-4">
                    <h5 className="card-title d-flex justify-content-center">{membership.constituent.displayName}</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-4 d-flex justify-content-center">{memberships?.attributes.children?.value}</div>
            <div className="col-4 d-flex justify-content-center">{household?.id}</div>
                <div className="col-4 d-flex justify-content-center">{formattedExpirationDate}</div>
            </div>
            {household && 
            <div className="row">
                <div className="col-12">
                    <div>{household.name}</div>
                    <div>{household.address?.addressLine1}</div>
                    {household.address?.addressLine2 && <div>{household.address?.addressLine2}</div>}
                    {household.address?.addressLine3 && <div>{household.address?.addressLine3}</div>}
                    <div>{household.address?.city}, {household.address?.state} {household.address?.postalCode}</div>
                </div>
            </div>}
        </div>
    </div>
}